module.exports = __webpack_public_path__ + "img/ribbon.06d0819f.svg";